import { useAppDispatch } from "app.hook";
import { FormikErrors, FormikProps, useFormik } from "formik";
import React, { FC, useEffect } from "react";
import {  ACCOUNT_FORGOT_PASSWORD_ROUTE, ACCOUNT_REGISTER_ROUTE, ACCOUNT_RESET_PASSWORD_ROUTE } from "shared/constants/routes";
import useCallback from "shared/hooks/use-callback";
import { ILoginRequestModel } from "states/account/account.models";
import { loginRequest, setLoading, showError } from "states/global-value/global-value.slice";
import { PrimaryButton } from "themes/style-components/button";
import { FormControl, FormError, FormGroup, FormGroupNotFlex } from "themes/style-components/form-group";
import { LinkStyle } from "themes/style-components/link";
import { H1, H2, H3, H5, TextLinkPrimary } from "themes/style-components/typography";
import { LoginPageContainer, LoginPageTextBottom } from "./style/login-style";



const LoginPage: FC = (props) => {
  const dispatch = useAppDispatch();
  const [callbackQuery, callbackUrl] = useCallback("callback");
  const formik: FormikProps<ILoginRequestModel> = useFormik<ILoginRequestModel>({
    initialValues: {
      userName: "",
      password: "",
    },
    validateOnChange: true,
    validate: (values) => {
      let errors: FormikErrors<ILoginRequestModel> = {};
      if (values.userName === "") {
        errors.userName = "Please enter user name ";
      }
      if (values.password === "") {
        errors.password = "Please enter password";
      }
      return errors;
    },
    onSubmit: async (values) => {
      await handleLogin(values);
    },
  });
  const handleLogin = async (value :ILoginRequestModel) => {
    dispatch(setLoading(true));
    try{
      await dispatch(loginRequest(value)).unwrap();
      if(callbackUrl !== ""){
        window.location.href = callbackUrl
      }
      dispatch(setLoading(false));
    }
    catch(rejectedValueOrSerializedError){
      dispatch(setLoading(false));
      dispatch(showError(rejectedValueOrSerializedError as any));
    }
  }
  useEffect(() => {
    document.title = "Login Page";
  }, [])
  return (
    <LoginPageContainer>
      <H5 className="mb-4">Login Page</H5>
      <form onSubmit={formik.handleSubmit}>
        <FormGroupNotFlex>
          <FormControl>
            <input
              id="userName"
              name="userName"
              type="text"
              placeholder="Username/Email"
              aria-placeholder="Username/Email"
              onChange={formik.handleChange}
              value={formik.values.userName}
               />
          </FormControl>
          {formik.errors.userName && (
            <FormError>
              {formik.errors.userName}
            </FormError>
          )}
        </FormGroupNotFlex>
        <FormGroupNotFlex className="mt-4">
          <FormControl>
            <input id="password"
              name="password"
              type="password"
              placeholder="Password"
              aria-placeholder="Password"
              onChange={formik.handleChange}
              value={formik.values.password} />
          </FormControl>
          {formik.errors.password && (
            <FormError>
              {formik.errors.password}
            </FormError>
          )}
        </FormGroupNotFlex>
        <PrimaryButton className="block w-full mt-4" type="submit">Submit</PrimaryButton>
        <LinkStyle to={`${ACCOUNT_FORGOT_PASSWORD_ROUTE}${callbackQuery}`} className="mt-2" >Forgot Password?</LinkStyle>
        <div className="text-center mt-8">
          <LoginPageTextBottom>Do not have an account? <TextLinkPrimary to={`${ACCOUNT_REGISTER_ROUTE}${callbackQuery}`}>Register</TextLinkPrimary> </LoginPageTextBottom>
        </div>
      </form>
    </LoginPageContainer>
  );
};

export default LoginPage;
